import { render, staticRenderFns } from "./Colaborador.vue?vue&type=template&id=305debe5&"
import script from "./Colaborador.vue?vue&type=script&lang=js&"
export * from "./Colaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports